<script>
import { AgGridVue } from 'ag-grid-vue3'

import { defaultColDef, sideBar } from '.'
import tableColumsState from '~/plugins/ag-grid/mixins/table-columns-state'
import tableFilterable from '~/plugins/ag-grid/mixins/table-filterable'
import tableNonReactiveData from '~/plugins/ag-grid/mixins/table-non-reactive-data'
import tableResize from '~/plugins/ag-grid/mixins/table-resize'

export const topScrollPositions = {}

export default {
  name: 'DataTable',
  components: {
    AgGridVue
  },
  mixins: [
    tableFilterable,
    tableColumsState,
    tableNonReactiveData,
    tableResize
  ],
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    shouldSetLastScrollPosition: {
      type: Boolean,
      default: false
    },
    suppressSidebar: {
      type: Boolean,
      default: false
    },
    enableGrouping: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      required: true
    },
    rowSelection: {
      type: Object,
      default: null
    }
  },
  emits: ['grid-ready', 'selection-changed'],
  data: ({ gridBodyScroll }) => ({
    sideBar,
    gridOptions: {
      getContextMenuItems: () => [],
      onBodyScroll: gridBodyScroll,
      cacheQuickFilter: true,
      onFirstDataRendered: params => {
        params.api.autoSizeAllColumns()
      },
      defaultColDef
    }
  }),
  watch: {
    shouldSetLastScrollPosition: {
      async handler () {
        if (this.shouldSetLastScrollPosition) {
          await nextTick()
          this.gridOptions.api.gridBodyCtrl.bodyScrollFeature.eBodyViewport
            .scrollTo(0, topScrollPositions[this.$route.name] || 0)
        }
      },
      immediate: true
    }
  },
  beforeMount () {
    if (!this.suppressSidebar) {
      this.sideBar.toolPanels[1].toolPanelParams.suppressRowGroups = !this.enableGrouping
    }
  },
  methods: {
    gridBodyScroll (e) {
      if (e.direction !== 'vertical') return
      topScrollPositions[this.$route.name] = e.top
    },
    onGridReady (params) {
      this.gridOptions.api = params.api

      this._setupFilter()
      this._setupColumnState()
      this._setupTableResize()
      this.$emit('grid-ready', params)
    },
    onSelectionChanged (params) {
      this.$emit('selection-changed', params)
    }
  }
}
</script>

<template>
  <AgGridVue
    class="ag-theme-alpine max-datatable"
    :style="{ height }"
    :grid-options="gridOptions"
    :side-bar="suppressSidebar ? null : sideBar"
    :row-selection="rowSelection"
    suppress-column-virtualisation
    v-bind="$attrs"
    @grid-ready="onGridReady"
    @selection-changed="onSelectionChanged"
  />
</template>

<style lang="scss">
.max-datatable {
  width: 100%;

  .ag-center-cols-container,
  .ag-pinned-right-cols-container {
    margin-right: 0 !important;
  }
}

</style>
